import { Link } from "react-router-dom";
import { COMPANY, LOGO_URL, SERVICE_AREA, SERVICES } from "@/lib/data";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#06090F] text-white pt-20 pb-10 border-t border-white/5"
    >
      <div className="absolute top-0 inset-x-0 h-[3px] bg-messinger-orange" />
      <div className="absolute inset-0 blueprint-grid opacity-40 pointer-events-none" />

      <div className="container-x relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src={LOGO_URL}
              alt="Messinger Logo"
              className="h-12 w-auto max-w-[220px] object-contain mb-6"
              style={{ filter: "invert(1) brightness(2)" }}
            />
            <p className="text-sm text-white/70 leading-relaxed mb-6">
              Unabhängiger KFZ-Sachverständiger & KFZ-Meister in {COMPANY.city}.
              Persönlich, präzise, schnell — für Privat- und Geschäftskunden.
            </p>
            <div className="space-y-3 text-sm text-white/70">
              <a
                href={COMPANY.phoneHref}
                data-testid="footer-phone"
                className="flex items-center gap-3 hover:text-messinger-orange transition-colors"
              >
                <Phone size={15} className="text-messinger-orange" />
                {COMPANY.phone}
              </a>
              <a
                href={COMPANY.emailHref}
                data-testid="footer-email"
                className="flex items-center gap-3 hover:text-messinger-orange transition-colors"
              >
                <Mail size={15} className="text-messinger-orange" />
                {COMPANY.email}
              </a>
              <div className="flex items-start gap-3">
                <MapPin size={15} className="text-messinger-orange mt-0.5" />
                <span>
                  {COMPANY.address.street}
                  <br />
                  {COMPANY.address.zip} {COMPANY.address.city}
                </span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-[0.18em] uppercase text-messinger-orange mb-5">
              Leistungen
            </h4>
            <ul className="space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/leistungen/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-white/70 hover:text-messinger-orange transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-[0.18em] uppercase text-messinger-orange mb-5">
              Einzugsgebiet
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              {SERVICE_AREA.map((city) => (
                <li key={city} className="flex items-center gap-2">
                  <span className="h-1 w-1 bg-messinger-orange rounded-full" />
                  {city}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-[0.18em] uppercase text-messinger-orange mb-5">
              Rechtliches
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/kontakt"
                  className="text-white/70 hover:text-messinger-orange transition-colors"
                >
                  Kontakt
                </Link>
              </li>
              <li>
                <Link
                  to="/impressum"
                  data-testid="footer-impressum"
                  className="text-white/70 hover:text-messinger-orange transition-colors"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  data-testid="footer-datenschutz"
                  className="text-white/70 hover:text-messinger-orange transition-colors"
                >
                  Datenschutz
                </Link>
              </li>
            </ul>

            <div className="mt-8 border border-white/10 rounded-full p-4 bg-white/5">
              <p className="text-[11px] uppercase tracking-[0.18em] text-messinger-orange mb-2">
                WhatsApp
              </p>
              <a
                href={COMPANY.whatsappHref}
                className="text-sm text-white hover:text-messinger-orange transition-colors"
              >
                {COMPANY.whatsapp}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <span>
            © {new Date().getFullYear()} {COMPANY.name} · Alle Rechte
            vorbehalten.
          </span>
          <span className="tracking-[0.18em] uppercase">
            Vertrauen · Kompetenz · Transparenz
          </span>
        </div>
      </div>
    </footer>
  );
}
